import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as room from '../room'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: room.RESOURCE.payload.dimension.partialId,
      partialId: room.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Industry-standard code to describe the use of a room',
    isOptional: true,
    name: 'HEGIS Code',
    partialId: PartialId.Standard.create('hegis'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
